var buttons = {
    base: {
        appearance: "none",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
        width: "100%",
        justifyContent: "center",
        height: "var(--button-height)",
        cursor: "pointer",
        border: "1px solid",
        borderRadius: 3,
        font: "body",
        fontWeight: "bold",
        lineHeight: 4,
        whiteSpace: "nowrap",
        userSelect: "none",
        "--colors-shadow": "var(--button-color-shadow)",
        "> *": {
            verticalAlign: "middle",
        },
        ":focus:not(:disabled):not([data-disabled='true'])": {
            boxShadow: 0,
            outline: "none",
        },
        ":hover:not(:disabled):not([data-disabled='true'])": {
            boxShadow: 2,
        },
        ":active:not(:disabled):not([data-disabled='true'])": {
            boxShadow: "none",
        },
        ":disabled, &[data-disabled='true']": {
            opacity: 0.6,
            cursor: "not-allowed",
            boxShadow: "none",
        },
    },
    variants: {
        look: {
            primary: {
                backgroundColor: "var(--colors-action-primary-surface)",
                borderColor: "var(--colors-action-primary-border)",
                color: "var(--colors-action-primary-onsurface)",
            },
            secondary: {
                backgroundColor: "var(--colors-action-secondary-surface)",
                borderColor: "var(--colors-action-secondary-border)",
                color: "var(--colors-action-secondary-onsurface)",
            },
            tertiary: {
                backgroundColor: "var(--colors-action-tertiary-surface)",
                borderColor: "var(--colors-action-tertiary-border)",
                color: "var(--colors-action-tertiary-onsurface)",
            },
            link: {
                backgroundColor: "transparent",
                border: "none",
                color: "var(--colors-action-foreground)",
                display: "inline-block",
                lineHeight: "inherit",
                height: "auto",
                width: "auto",
                padding: "0",
                ":hover:not(:disabled):not([data-disabled='true'])": {
                    border: "none",
                    boxShadow: "none",
                    textDecoration: "underline",
                },
                ":focus:not(:disabled):not([data-disabled='true'])": {
                    border: "none",
                    outline: "none",
                    textDecoration: "underline",
                },
                ":disabled, &[data-disabled='true']": {
                    textDecoration: "none",
                },
            },
            naked: {
                backgroundColor: "transparent",
                border: "none",
                color: "var(--colors-action-foreground)",
                ":hover:not(:disabled):not([data-disabled='true'])": {
                    border: "none",
                    boxShadow: "none",
                },
                ":focus:not(:disabled):not([data-disabled='true'])": {
                    border: "none",
                    outline: "none",
                },
            },
        },
        tone: {
            // define 3 colors for the button component here
            primary: {
                "--button-color-shadow": "var(--colors-action-primary-shadow)",
            },
            secondary: {
                "--button-color-shadow": "var(--colors-action-secondary-shadow)",
            },
            success: {
                "--colors-action-foreground": "var(--colors-success-100)",
                "--colors-action-primary-onsurface": "var(--colors-white)",
                "--colors-action-primary-surface": "var(--colors-success-60)",
                "--colors-action-primary-border": "var(--colors-success-60)",
                "--colors-action-secondary-surface": "white",
                "--colors-action-secondary-border": "var(--colors-success-60)",
                "--colors-action-secondary-onsurface": "var(--colors-success-60)",
                "--colors-action-tertiary-onsurface": "var(--colors-success-60)",
                "--colors-action-tertiary-surface": "var(--colors-success-5)",
                "--button-color-shadow": "var(--colors-success-shadow)",
            },
            warning: {
                "--colors-action-foreground": "var(--colors-warning-100)",
                "--colors-action-primary-onsurface": "var(--colors-white)",
                "--colors-action-primary-surface": "var(--colors-warning-60)",
                "--colors-action-primary-border": "var(--colors-warning-60)",
                "--colors-action-secondary-onsurface": "var(--colors-warning-60)",
                "--colors-action-secondary-surface": "white",
                "--colors-action-secondary-border": "var(--colors-warning-60)",
                "--colors-action-tertiary-onsurface": "var(--colors-warning-60)",
                "--colors-action-tertiary-surface": "var(--colors-warning-5)",
                "--button-color-shadow": "var(--colors-warning-shadow)",
            },
            critical: {
                "--colors-action-foreground": "var(--colors-critical-100)",
                "--colors-action-primary-onsurface": "var(--colors-white)",
                "--colors-action-primary-surface": "var(--colors-critical-60)",
                "--colors-action-primary-border": "var(--colors-critical-60)",
                "--colors-action-secondary-surface": "white",
                "--colors-action-secondary-border": "var(--colors-critical-60)",
                "--colors-action-secondary-onsurface": "var(--colors-critical-60)",
                "--colors-action-tertiary-onsurface": "var(--colors-critical-60)",
                "--colors-action-tertiary-surface": "var(--colors-critical-5)",
                "--button-color-shadow": "var(--colors-critical-shadow)",
            },
            inherit: {
                color: "inherit",
                "--colors-action-primary-surface": "inherit",
                "--colors-action-secondary-surface": "inherit",
                "--colors-action-tertiary-surface": "inherit",
            },
            white: {
                color: "var(--colors-action-foreground)",
                bg: "white",
                border: "white",
                "--button-color-shadow": "var(--colors-action-primary-shadow)",
            },
        },
        bold: {
            false: {
                fontWeight: "body",
            },
        },
        size: {
            xs: {
                fontSize: "xs",
                "--button-height": "26px",
                padding: "0 8px",
            },
            sm: {
                fontSize: "sm",
                "--button-height": "33px",
                padding: "0 16px",
            },
            md: {
                "--button-height": "44px",
                padding: "0 24px",
            },
            lg: {
                fontSize: "lg",
                "--button-height": "56px",
                padding: "0 32px",
            },
            inherit: {
                fontSize: "inherit",
                fontWeight: "inherit",
                "--button-height": "100%",
                padding: 0,
                justifyContent: "center",
            },
        },
        rounded: {
            true: {
                borderRadius: "calc(var(--button-height)/2)",
            },
        },
    },
    variantOrder: ["rounded", "size", "look", "tone", "disabled", "bold"],
};

export { buttons };
//# sourceMappingURL=buttons.js.map
